module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add-files":"Datei hochladen","btn-cancel":"Schliessen","btn-upload":"Hochladen und schliessen","upload":"hochladen"},"fr":{"add-files":"Télécharger fichier","btn-cancel":"Fermer","btn-upload":"Télécharger et fermer","upload":"télécharger"},"it":{"add-files":"Caricare file","btn-cancel":"Chiudere","btn-upload":"Caricare e chiudere","upload":"caricare"}}')
  delete Component.options._Ctor
}
